import { NavLink, Link } from "react-router";
import classes from "./Footer.module.css";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { treatmentNavLinks } from "../../routes/Services/serviceData";
import {
  BOOKING_URL,
  trackBookingClick,
  trackContactClick,
  trackSocialClick,
  trackNavClick,
} from "../../utils/tracking";
import GoogleIcon from '@mui/icons-material/Google';
import { reviews } from "../../routes/Reviews/clientReviews";
import { renderStars } from "../../routes/Reviews/Reviews";

const instagramLink = "https://www.instagram.com/rnradianceaesthetics/";
const facebookLink =
  "https://www.facebook.com/share/1KRjysaqyD/?mibextid=wwXIfr";
const googleLink =
  "https://www.google.com/maps/place/Radiance+Aesthetics/@53.5295651,-2.5672978,150m/data=!3m1!1e3!4m6!3m5!1s0x487b07c9ffe524bf:0xb10b2aea66168f00!8m2!3d53.5297078!4d-2.5669908!16s%2Fg%2F11vpm3jf71?entry=ttu&g_ep=EgoyMDI1MDkyOC4wIKXMDSoASAFQAw%3D%3D";
const emailLink = "mailto:elisha@rnradianceaesthetics.com";
const phoneLink = "tel:07555379004";

const clauclateAverageRating = (reviews) => {
  if (reviews.length === 0) return 0;
  const totalRating = reviews.reduce((sum, review) => sum + review.rating, 0);
  return (totalRating / reviews.length).toFixed(1); // Round to 1 decimal place
}

const Footer = () => {
  const averageRating = clauclateAverageRating(reviews);

  return (
    <footer className={classes.footerColourSection}>
      <div className={classes.footerContainer}>
        <div className={classes.footerGrid}>
          <div className={classes.footerBrand}>
            <h3 className={classes.footerBrandName}>Radiance Aesthetics</h3>
            <p className={classes.footerBrandText}>
              Nurse-led aesthetics clinic in Hindley, Wigan. Advanced skin
              treatments delivered with clinical expertise and personalised
              care.
            </p>
            <div className={classes.footerSocials}>
              <a
                href={instagramLink}
                target="_blank"
                rel="noreferrer"
                className={classes.footerSocialLink}
                aria-label="Follow us on Instagram"
                onClick={() => trackSocialClick("Instagram", "Footer")}
              >
                <InstagramIcon sx={{ fontSize: 18 }} />
              </a>
              <a
                href={facebookLink}
                target="_blank"
                rel="noreferrer"
                className={classes.footerSocialLink}
                aria-label="Follow us on Facebook"
                onClick={() => trackSocialClick("Facebook", "Footer")}
              >
                <FacebookIcon sx={{ fontSize: 18 }} />
              </a>
              <a
                href={googleLink}
                target="_blank"
                rel="noreferrer"
                className={classes.footerSocialLink}
                aria-label="Find us on Google Maps"
                onClick={() => trackContactClick("directions", "Footer")}
              >
                <LocationOnIcon sx={{ fontSize: 18 }} />
              </a>
              <a
                href={phoneLink}
                className={classes.footerSocialLink}
                aria-label="Call us"
                onClick={() => trackContactClick("phone", "Footer Icons")}
              >
                <PhoneIcon sx={{ fontSize: 18 }} />
              </a>
              <a
                href={emailLink}
                className={classes.footerSocialLink}
                aria-label="Email us"
                onClick={() => trackContactClick("email", "Footer Icons")}
              >
                <EmailIcon sx={{ fontSize: 18 }} />
              </a>
            </div>
            <h4 className={classes.footerHeading} style={{ marginTop: "20px" }}>
              Opening Hours
            </h4>
            <p className={classes.footerHours}>Mon – Sat: 9:00am – 5:00pm</p>
            <p className={classes.footerHours}>Sun: Closed</p>
            <a
              href={googleLink}
              target="_blank"
              rel="noreferrer"
              className={classes.footerGoogleRating}
              aria-label={`${averageRating} out of 5 on Google, based on ${reviews.length} reviews`}
              onClick={() => trackSocialClick("Google Reviews", "Footer")}
            >
              <div className={classes.footerGoogleRatingHeader}>
                <GoogleIcon sx={{ fontSize: 16 }} />
                <span>Google Reviews</span>
              </div>
              <div className={classes.footerGoogleRatingScore}>
                <span className={classes.footerGoogleRatingNumber}>
                  {averageRating}
                </span>
                <span className={classes.footerGoogleRatingStars}>
                  {renderStars(averageRating)}
                </span>
              </div>
              <p className={classes.footerGoogleRatingCount}>
                Based on {reviews.length} reviews
              </p>
            </a>
          </div>
          <div>
            <h4 className={classes.footerHeading}>Visit Us</h4>
            <address className={classes.footerAddress}>
              <p>Laurel House (above Yoga Universe)</p>
              <p>Atherton Road</p>
              <p>Hindley, Wigan</p>
              <p>WN2 3XD</p>
            </address>
            <p className={classes.footerContact}>
              <a
                href={phoneLink}
                onClick={() => trackContactClick("phone", "Footer Visit Us")}
              >
                07555 379004
              </a>
            </p>
            <p className={classes.footerContact}>
              <a
                href={emailLink}
                onClick={() => trackContactClick("email", "Footer Visit Us")}
              >
                elisha@rnradianceaesthetics.com
              </a>
            </p>
            <nav aria-label="Information" style={{ marginTop: "20px" }}>
              <h4 className={classes.footerHeading}>Information</h4>
              <ul className={classes.footerLinks}>
                <li>
                  <Link
                    to="/reviews"
                    onClick={() => trackNavClick("Reviews", "Footer")}
                  >
                    Reviews
                  </Link>
                </li>
                <li>
                  <Link
                    to="/aftercare"
                    onClick={() => trackNavClick("Aftercare", "Footer")}
                  >
                    Aftercare
                  </Link>
                </li>
                <li>
                  <NavLink
                    to="/cancellation-policy"
                    onClick={() =>
                      trackNavClick("Cancellation Policy", "Footer")
                    }
                  >
                    Cancellation Policy
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/privacy-policy"
                    onClick={() => trackNavClick("Privacy Policy", "Footer")}
                  >
                    Privacy Policy
                  </NavLink>
                </li>
              </ul>
            </nav>
          </div>

          <div>
            <nav aria-label="Treatments">
              <h4 className={classes.footerHeading}>Treatments</h4>
              <ul className={classes.footerLinks}>
                {treatmentNavLinks.map(({ to, label }) => (
                  <li key={to}>
                    <Link
                      to={to}
                      onClick={() => trackNavClick(label, "Footer")}
                    >
                      {label}
                    </Link>
                  </li>
                ))}
                <li>
                  <a
                    href={BOOKING_URL}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => trackBookingClick("Footer")}
                  >
                    Book Now
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div className={classes.footerBottom}>
          <p className={classes.footerCopyright}>
            &copy; 2026 Radiance Aesthetics. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
